import APIConnector from "../lib/APIConnector";
import Settings from '../base/Settings'
const apiConnector = new APIConnector({ timeout: 30000 })

export default class RolConfig {
  static get endpoint(){
    return Settings.SERVICE_DOMAIN
  }
  static get endpointTags() {
    return `${RolConfig.endpoint}/tags`;
  }
  static get endpointSaveTag() {
    return `${RolConfig.endpointTags}/save`;
  }
  static get endpointDeleteTag() {
    return `${RolConfig.endpointTags}/delete`;
  }
  static get endpointDeleteTagFromUser() {
    return `${RolConfig.endpointTags}/deleteFromUser`;
  }
  static get APIConnector() {
    return apiConnector
  }
}



// WEBPACK FOOTER //
// ./src/provider/tag/TagConfig.js